import { Checkbox } from 'src/components/atoms/Checkbox/Checkbox';
import { RadioButton } from 'src/components/atoms/RadioButton/RadioButton';
import { StyledText } from 'src/components/foundations/foundations.styles';
import { textStyleCss } from 'src/theme/atlas';
import styled, { keyframes } from 'styled-components';

const fadeOut = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

const shrink = keyframes`
  0% {
    padding-top: 78px;
  }
  100% {
    padding-top: 0;
  }
`;

export const FadeOutHeading = styled.div<{ animationDuration: number }>`
  animation: ${fadeOut} ${({ animationDuration }) => animationDuration}ms;
  animation-time-function: ease-out;
`;

export const SlideUp = styled.div<{
  animationDuration: number;
  animationDelay: number;
  fadeOutComplete: boolean;
  marginBottom: number;
}>`
  ${({ fadeOutComplete }) => fadeOutComplete && 'padding-top: 78px;'}
  animation: ${shrink} ${({ animationDuration }) => animationDuration}ms;
  animation-delay: ${({ animationDelay }) => animationDelay}ms;
  animation-fill-mode: forwards;
  animation-time-function: ease-out;
  margin-bottom: ${({ marginBottom }) => marginBottom}px;
`;

export const StyledSubheaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 30px;
`;

export const AccessStepDescription = styled(StyledText)`
  margin: 5px 0 0 0;
`;

export const AccessStepIntro = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

export const GlobalAccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
`;

export const DividerContainer = styled.div`
  padding: 20px 0 0 0;
`;

export const AccessTypeContainer = styled.div`
  display: flex;
  gap: 40px;
`;

export const AccessStyleBody = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
`;

export const AccessItemTitle = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.emphasis)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const AccessItemPIIContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding-top: 10px;
  margin: 0;
`;

export const AccessItemPII = styled.div`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const StyledRadioButton = styled(RadioButton)`
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  width: 24px;
  height: 24px;

  &:checked {
    border: 6px solid;
    border-color: ${(props) =>
      props.theme.atlas.semantic.color.action.primary.default};
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  width: 20px;
  height: 20px;
`;

export const PIISectionItem = styled.div`
  padding-left: 32px;
  margin-top: 8px;
`;

export const PIISectionItemWrappper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 5px 10px;
`;
